import { MouseEvent, ReactNode, useEffect } from 'react'

import PlainModal, { HandleModalDisplayed, PlainModalContent, PlainModalFooter, PlainModalHeader } from 'app/common/ui-next/plain-modal'
import PlainButton from 'app/common/ui-next/plain-button'
import ControlsBar from 'app/common/ui-next/controls-bar'

import useSubmit from './useSubmit'
import AdditionalSettingsForm from './AdditionalSettingsForm'
import { useAdditionalSettings } from 'app/dataProviders/dishes/DishesData/additionalSettings/hooks'

const emptyProps = Object.freeze({})

type Dish = {
  id: number | null
  title: string
}
type Props = {
  orgId: string
  dish: Dish
  writeAccess: boolean
  onClose: (e?: MouseEvent<HTMLElement>) => void
  children?: (handleVisibility: HandleModalDisplayed) => ReactNode
}

export const AdditionalSettingsModal = ({
  orgId,
  dish,
  writeAccess,
  onClose,
  children,
}: Props) => {
  const [submitting, submit] = useSubmit({ orgId, dishId: dish.id, onSubmitSuccess: onClose })
  const dishId = dish.id ?? undefined
  const { data, loading, requestRef } = useAdditionalSettings({
    autoload: false,
    autoupdate: false,
    params: {
      orgId,
      dishId
    }
  })
  const viewProps = children ? emptyProps : { show: true }

  useEffect(() => {
    if (dish.id) {
      requestRef.current()
    }
  }, [orgId, dish.id, requestRef])

  if (!writeAccess || !dish.id) return null

  return (
    <PlainModal
      formId="complex_additional_settings"
      onSubmit={submit}
      controlBy={children}
      {...viewProps}
    >
      <PlainModalHeader onCrossClick={onClose}>{'Дополнительные настройки'}</PlainModalHeader>
      <PlainModalContent>
        <AdditionalSettingsForm
          disableForTerminalGuestSales={data.disableForTerminalGuestSales}
          disabled={submitting}
          loading={loading}
        />
      </PlainModalContent>
      <PlainModalFooter>
        {toggle => (
          <ControlsBar right>
            <PlainButton
              outline
              onClick={onClose}
            >
              {'Отмена'}
            </PlainButton>

            <PlainButton
              type="submit"
              disabled={submitting}
            >
              {submitting ? 'Сохранение...' : 'Сохранить'}
            </PlainButton>
          </ControlsBar>
        )}
      </PlainModalFooter>
    </PlainModal>
  )
}
